"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const komputerContents: ReactNode = (
  <>
    <h2 className="text-2xl font-bold mb-4 leading-tight">Sewa Komputer: Solusi Cerdas, Fleksibel, dan Anti Ribet</h2>
    <p className="mb-6 text-base">
      Beli komputer mahal demi kebutuhan jangka pendek? Sayang sekali. Di era efisiensi dan adaptif ini, <strong>sewa komputer</strong> bukan cuma alternatif tapi jawaban. Fleksibel durasinya, beragam pilihannya, dan hemat biayanya. Ideal
      untuk kantor, event, proyek kreatif, atau bahkan gaming!
    </p>
    <section className="grid gap-6 md:grid-cols-2">
      <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
        <h3 className="font-semibold text-lg mb-2">Harga Sewa Komputer? Transparan dan Bisa Disesuaikan</h3>
        <p className="text-sm">
          Mulai dari kebutuhan <strong>harian, mingguan, bulanan</strong> semua tersedia. Kami bantu kamu temukan paket <strong>harga sewa komputer</strong> yang paling masuk akal tanpa perlu pusing mikirin biaya tersembunyi.
        </p>
      </div>
      <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
        <h3 className="font-semibold text-lg mb-2">Beragam Brand & Spesifikasi Siap Kerja</h3>
        <p className="text-sm">
          Dari <strong>komputer gaming, workstation editing, sampai kebutuhan kantor ringan</strong>, semua ada. Brand? ASUS, Lenovo, Dell, HP siap antar dengan spek terbaik. Mau i3, i5, i7 atau Ryzen? Tinggal pilih.
        </p>
      </div>
      <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
        <h3 className="font-semibold text-lg mb-2">Layanan Sewa Komputer Terdekat, Real-Time & Cepat</h3>
        <p className="text-sm">
          Pusat kami tersebar di Jabodetabek, Surabaya, Bandung, Medan, dan kota besar lainnya. Mau cari <strong>sewa komputer terdekat</strong>? Tim kami langsung kirim. Hari ini order, hari ini juga datang.
        </p>
      </div>
      <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
        <h3 className="font-semibold text-lg mb-2">Instalasi, Maintenance, dan Support? Full Service!</h3>
        <p className="text-sm">
          Mulai dari setup awal, software, jaringan, sampai troubleshooting. <strong>Tim teknisi kami aktif 24 jam</strong>. Butuh ganti unit? Langsung tukar. Sewa komputer bukan cuma tentang perangkat tapi juga service yang paripurna.
        </p>
      </div>
    </section>
    <div className="mt-8">
      <h2 className="text-xl font-bold mb-3">Pilihan Komputer Sewa yang Bikin Produktivitas Naik Level</h2>
      <ul className="list-disc pl-5 text-sm space-y-2">
        <li>PC Office: Ringan, efisien, cocok untuk admin & kasir</li>
        <li>Komputer Editing: GPU & RAM tinggi, cocok buat desain & video</li>
        <li>Komputer Gaming: Full spek untuk turnamen dan event</li>
        <li>Workstation Developer: Stabil dan cepat untuk coding & testing</li>
        <li>iMac: Spek cantik performa ciamik</li>
      </ul>
    </div>
    <div className="mt-8">
      <h2 className="text-xl font-bold mb-3">Kenapa Harus Sewa Komputer di Kami?</h2>
      <ul className="space-y-4">
        <li className="bg-gray-50 border-l-4 border-blue-500 p-4 rounded-xl"><strong>Layanan Cepat</strong> Waktu adalah aset. Kami bergerak cepat demi efisiensi kerja kamu.</li>
        <li className="bg-gray-50 border-l-4 border-green-500 p-4 rounded-xl"><strong>Teknologi Terbaru</strong> Komputer kami selalu di-upgrade rutin agar tetap relevan & powerful.</li>
        <li className="bg-gray-50 border-l-4 border-yellow-500 p-4 rounded-xl"><strong>Harga Terbaik</strong> Tanpa biaya tersembunyi, bisa disesuaikan dengan kebutuhan.</li>
        <li className="bg-gray-50 border-l-4 border-red-500 p-4 rounded-xl"><strong>Support 24 Jam</strong> Problem? Kami selesaikan. Kapan saja.</li>
      </ul>
    </div>

    <CTA
      title="Siap Editing & Olah Data Bosku?"
      description="🚚 Butuh sewa komputer terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Komputer Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20komputer.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Komputer"
    />
  </>
);
